export enum UpdateStatus { WAITING, UPDATING, FINISH, ERROR }